import $ from 'jquery';
import m from "../../prime-src/prepare";
import Reset from './Reset';
import Exit from './Exit';

export default function FormNewReco() {
  return (
    <div id="new-reco">
      <form>
        <label htmlFor="input-uri">URI <span className="desc">(required)</span></label>
        <textarea className="single-line" id="input-uri" name="uri" placeholder="Unique Resource Indentifier: like http-URL (max 255 length)" tabIndex={1}></textarea>
        <Reset onClick={(event) => {
          m.$input_uri[0].value = "";
          m.$input_uri.trigger("focus");
          m.$input_uri.trigger("keyup");
        }}></Reset>
        <label htmlFor="input-title">Title <span className="desc"><code>Ctrl+Enter</code> to Reco/Edit
            directly</span></label>
        <div id="def-titles"></div>
        <textarea className="single-line" id="input-title" name="title" placeholder="Title" tabIndex={2}></textarea>
        <div id="lyrics-search" className="button fRight">Lyrics Search in genius.com</div>
        <div className="cBoth"></div>
        <label htmlFor="input-cats">Categories</label>
        <div id="def-cats">
          <div className="def-cat replace-cat">Indifferent</div>
          <div className="def-cat replace-cat">Later</div>
          <div className="def-cat replace-cat">Stashed</div>
          <div id="add-cat" className="def-cat add-txt">;</div>
          <div id="sub-cat" className="def-cat add-txt">--</div>
          <div id="delete-cat" className="def-cat delete-cat">Delete</div>
        </div>
        <textarea className="single-line" id="input-cats" name="cats" placeholder="Category--Sub category--Subsub category ; Another category ; ..." tabIndex={3}></textarea>
        <div id="cat-fs-container" className="fs-container" style={{display:'none'}}>
          <div id="cat-fs-list" className="fs-list"></div>
          <Exit id="exit-cat-fs-container" onClick={(e) => $(e.target).parents(".fs-container").hide()}/>
        </div>
        <div className="buttons">
          <div className="button fLeft button-close" tabIndex={4} onClick={() => m.closeNewReco()}>Close</div>
          <div className="button fLeft button-back" tabIndex={5}>Back</div>
          <div className="button button-reco" tabIndex={6}>Reco</div>
          <div className="button button-edit" tabIndex={7}>Edit</div>
          <div className="button button-del" tabIndex={8} style={{background:'#ff7600'}}>Del</div>
          <div className="cBoth"></div>
        </div>
        <div style={{margin:'.5em 0'}}>
          <label className="label-input-val" htmlFor="input-val">Points</label>
          <div className="input-val-stars"></div>
          <span className="upDown input-val-up">&gt;</span>
          <span className="upDown input-val-down">&lt;</span>
          <input className="input-val" name="val" placeholder="(ex: 7.5/10)" type="text" tabIndex={9} />
          <div className="cBoth"></div>
        </div>
        <div id="error-msg" className="cBoth"></div>
        <div id="show-URI"></div>
        <label htmlFor="input-desc">Description</label>
        <div id="def-cmds">
          <div id="preview-desc">Preview</div>
          <div className="def-cmd">#related</div>
          <div className="def-cmd">#lyrics</div>
          <div id="formatting-lyrics">Formatting the lyrics (mainly from genius.com)</div>
          <div className="def-cmd">#dictionary</div>
        </div>
        <div id="def-descs"></div>
        <textarea className="multi-line" id="input-desc" name="desc" placeholder="Objective Description: You can refer a good description of others. In other words, you can provide a good description to the others." tabIndex={10}></textarea>
        <div id="previewed-desc"></div>
        <label htmlFor="input-cmt">Comment</label>
        <textarea className="multi-line" id="input-cmt" name="cmt" placeholder="Comment: your personal description or opinion on this URI." tabIndex={11}></textarea>
        <div id="my-reco"></div>
        <Exit id="exit-new-reco" style={{ margin: '-1em -.2em 0 0' }} onClick={(e) => m.$button_close.trigger("click")}/>
        <div className="buttons">
          <div className="button fLeft button-close" tabIndex={12} onClick={() => m.closeNewReco()}>Close</div>
          <div className="button fLeft button-back" tabIndex={13}>Back</div>
          <div className="button button-reco" tabIndex={14}>Reco</div>
          <div className="button button-edit" tabIndex={15}>Edit</div>
          <div className="button button-del" tabIndex={16} style={{background:'#ff7600'}}>Del</div>
          <div className="cBoth"></div>
        </div>
        <div style={{margin:'.5em 0'}}>
          <label className="label-input-val" htmlFor="input-val">Points</label>
          <div className="input-val-stars"></div>
          <span className="upDown input-val-up">&gt;</span>
          <span className="upDown input-val-down">&lt;</span>
          <input className="input-val" name="val" placeholder="(ex: 7.5/10)" type="text" tabIndex={17} />
          <div className="cBoth"></div>
        </div>
      </form>
    </div>
  );
}
